import { string, object, SchemaOf } from 'yup'

export interface ILoginSchema {
    password: string
    email: string
}

const loginSchema: SchemaOf<ILoginSchema> = object().shape({
    email: string().email('E-mail inválido.').required('Preencha o campo com seu e-mail.').max(100, 'Máx 100 caracteres'),
    password: string().required('Preencha o campo com sua senha.').max(20, 'Máx 20 caracteres'),
})

export default loginSchema
